export default "__VITE_ASSET__CtQlHfI6__"